// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NMcYaUsJUUQN6IsJQhfO{height:24px;margin-top:-4px;margin-bottom:-4px}.dpPzirEVKZs8jAPITzVF{margin-top:8px}.dpPzirEVKZs8jAPITzVF.DLJccCXDXDw00gBN2_Dl{margin-top:0;margin-bottom:8px}.UuOrYhObjkRFRIQFuuRw{align-items:center;width:71px;display:flex}.Gy_9OTNC9SMVuGNqC8QZ{padding-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputAction": `NMcYaUsJUUQN6IsJQhfO`,
	"error": `dpPzirEVKZs8jAPITzVF`,
	"isTopError": `DLJccCXDXDw00gBN2_Dl`,
	"send": `UuOrYhObjkRFRIQFuuRw`,
	"textField": `Gy_9OTNC9SMVuGNqC8QZ`
};
export default ___CSS_LOADER_EXPORT___;
